import { render } from "./GenresList.vue?vue&type=template&id=ced1af44&scoped=true"
import script from "./GenresList.vue?vue&type=script&lang=js"
export * from "./GenresList.vue?vue&type=script&lang=js"

import "./genres.scss?vue&type=style&index=0&id=ced1af44&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced1af44"]])

export default __exports__